angular.module('unergie.main')
.controller('addTestFeeModalCtrl', ($scope, $uibModalInstance, XmlParser, ReferencesService, BoFeaturesService, AlertManager, ErrorCatcher,
    idContract, idGrd) => {
    $scope.idContract = idContract

    $scope.searchFee = ''

    ReferencesService.getRef('enedis-fees', true).then((enedisFees) => {
        $scope.enedisFees = _.filter(enedisFees, { distributor_name: 'erdf' })
    })

    $scope.generation = {
        type: 'F15-FL',
        target: 's3',
        bucket: `${BoFeaturesService.getEnv()}-unergie-files`,
        id_contract: idContract,
        id_grd: idGrd,
        payload: [],
    }

    $scope.addFee = function () {
        if (!$scope.canAdd()) {
            return
        }
        $scope.form.startDate = moment($scope.form.startDate).format('YYYY-MM-DD')
        $scope.form.endDate = moment($scope.form.endDate).format('YYYY-MM-DD')
        $scope.generation.payload.push($scope.form)
        $scope.resetForm()
    }

    $scope.delFee = (index) => $scope.generation.payload.splice(index, 1)

    const formTemplate = {
        id_fee: null,
        amount: 0,
        label: null,
        qty: 1,
        startDate: moment().toDate(),
        endDate: moment().toDate(),
    }

    $scope.canAdd = () => {
        return !!$scope.form.id_fee &&
            !!$scope.form.label &&
            !!$scope.form.amount &&
            $scope.form.qty != null
    }

    $scope.resetForm = () => {
        $scope.searchFee = ''
        $scope.form = _.clone(formTemplate)
    }

    $scope.resetForm()

    $scope.selectFee = (fee) => {
        $scope.form.id_fee = fee.id_fee
        $scope.form.label = fee.distributor_label
    }

    $scope.createFees = function () {
        $scope.creating = true
        return XmlParser.generation($scope.generation).$promise.then(() => {
            AlertManager.success('Fichier généré')
            $uibModalInstance.close()
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.creating = false
        })
    }

    $scope.close = () => $uibModalInstance.dismiss()
})
